/* eslint-disable react/react-in-jsx-scope */
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import FundingItem from "./FundingItem";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/ui/skeleton";
import { useFundingByProject } from "@/dashboard/store/store";

const FundingByProject = ({ year }: { year: number }) => {
  const [showAddNewFunding, setShowAddNewFunding] = useState<number[]>([]);
  const [renderFundingItems, setRenderFundingItems] = useState<any[]>([]);
  const [financeurs, setFinanceurs] = useState<any[]>({});
  const { t } = useTranslation("dashboard", {
    keyPrefix: "financeur",
  });

  const [dataReloaded, setDataReloaded] = useState(true);

  // const { data, loading, isRefreshing } = useFetchDataV2(
  //   `${import.meta.env.VITE_API_ENDPOINT}/real-fundings?by=project`,
  //   "real-fundings-project",
  //   1000 * 60 * 60
  // );
  const [loading, setLoading] = useState(true);
  const {data, setData} = useFundingByProject();
  const dataFinanceurs = useFetchDataV2(
    `${import.meta.env.VITE_API_ENDPOINT}/financers`,
    "financeurs",
    1000 * 60 * 60
  );
  const getColumns = (): ColumnDef<any>[] => [
    { accessorKey: "idFunding", header: "ID" },
    { accessorKey: "financier", header: t("Financeur") },
    { accessorKey: "representant", header: t("Représentant") },
    { accessorKey: "estimatedAmount", header: t("Montant estimé") },
    { accessorKey: "estimatedDate", header: t("Date estimé") },
    { accessorKey: "paidAmount", header: t("Montant versé") },
    { accessorKey: "dateAmount", header: t("Date versement") },
    { accessorKey: "actions", header: t("Actions") },
  ];

  const columns: ColumnDef<any>[] = getColumns();

  useEffect(() => {
    setLoading(true);
    if (!dataFinanceurs.loading) {
      setFinanceurs(dataFinanceurs);
    }
    dataFinanceurs.fetchData(`${import.meta.env.VITE_API_ENDPOINT}/real-fundings?by=project`).then((res) => {
      setData(res);
      setLoading(false);
    })
  }, []);

  useEffect(() => {
    if (!dataFinanceurs.loading) {
      setFinanceurs(dataFinanceurs);
    }
  }, [dataFinanceurs.loading]);

  // useEffect(() => {
  //   if (!isRefreshing) {
  //     setDataReloaded(true);
  //   } else {
  //     setDataReloaded(false);
  //   }
  // }, [isRefreshing]);

  useEffect(() => {
    const renderFundingItemsTems = data?.data?.map((funding) => {
      const fundingData = formatFundingData(funding);
      let totalFunding = 0;
      funding.desiredFunding.forEach((df) => {
        totalFunding += df.convertedAmount;
      });
      funding.obtainedFunding.forEach((of) => {
        totalFunding += of.convertedAmount;
      });

      return (
        <FundingItem
          key={funding.id}
          linkProject={`/dashboard/project/${funding.id}`}
          id={funding.id}
          name={funding.name}
          totalFunding={totalFunding}
          data={fundingData}
          year={year}
          columns={columns}
          financeurs={financeurs}
          setFinanceurs={setFinanceurs}
          showAddNewFunding={showAddNewFunding}
          setShowAddNewFunding={setShowAddNewFunding}
          currency={funding.country ? funding.country.currency : ""}
          type={"byProject"}
          dataReloaded={dataReloaded}
        />
      );
    });

    setRenderFundingItems(renderFundingItemsTems);
  }, [data, financeurs, dataReloaded]);

  if (loading || dataFinanceurs.loading) {
    return (
      <>
        <FundingSkeleton />
        <FundingSkeleton />
      </>
    );
  }

  return <div>{renderFundingItems}</div>;
};

const formatFundingData = (funding: any) => {
  return funding.realFundings?.length
    ? funding.realFundings
        .filter((item) => item.verdeoFundingInvoiced === null)
        .map((item: any) => ({
          idFunding: item.id,
          idProject: funding.id,
          financier:
            item.verdeoFundingPaid !== null
              ? item?.verdeoFundingPaid?.invoiced?.financer?.structureName
              : item?.financier?.structureName,
          representant: item.representant,
          estimatedAmount: item.estimatedAmount,
          estimatedDate: item.estimatedDate,
          paidAmount: item.paidAmount,
          dateAmount: item.dateAmount,
          isVerdeo: item.verdeoFundingPaid !== null,
          hasCertificate: item.hasCertificate,
          financierId: item.verdeoFundingPaid !== null
              ? item?.verdeoFundingPaid?.invoiced?.financer?.id
              : item?.financier?.id,
          projectName: funding.name
        }))
    : [];
};

export default FundingByProject;

export const FundingSkeleton = () => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "financeur",
  });
  return (
    <div className="mt-5 bg-[#F7F9FB] rounded-[20px] p-5">
      <Skeleton className=" w-[200px] h-5 mb-5 bg-[#ecedee]" />
      <div className="flex  gap-5 mt-5 pl-5 py-5">
        <div className="mr-8">
          <p>{t("Estimé")}</p>
          <p>{t("Versement")}</p>
        </div>
        <div className=" w-full flex flex-col gap-2 ml-10 mr-10">
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]" />
            ))}
          </div>
          <div className=" w-full flex flex-row gap-2">
            {Array.from({ length: 12 }).map((_, index) => (
              <Skeleton className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]" />
            ))}
          </div>
        </div>
      </div>
      <div className="ml-5 mr-10">
        <Skeleton className="w-full rounded-sm h-36 bg-[#ecedee]" />
      </div>
    </div>
  );
};
